export default __webpack_public_path__ + "static/media/team2.7f86daaf.jpg";